<template>
  <div class="cxandcz">
    <div class="search">
      <el-button type="primary" @click="search" icon="el-icon-search" round>搜索</el-button>
    </div>
    <el-button type="warning" @click="reset" icon="el-icon-refresh" round>重置</el-button>
  </div>
</template>

<script>
export default {
  name: "cxandczView",
  data() {
    return {

    };
  },
  methods: {
    // 搜索
    search() {
      this.$emit('search')
    },
    // 重置
    reset() {
      this.$emit('reset')
    }
  }

};
</script>

<style lang="scss" scoped>
.cxandcz {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .search {
    margin-right: 20px;
  }
}
</style>